<template>
	<div class="summary-page">
		<div class="row">
			<div class="col-12 text-center text-lg-left">
				<h1>
                    {{ $tr.summary.title }}
				</h1>
			</div>
		</div>
		<div class="row">
            <template v-if="requireCut && shirtConfigured">
                <div class="col-sm-4" v-for="value in this.$backendConfig.measurements.categories.base.cut.values" :key="value.id">
                    <label :class="{ selected: value.id === cut, invalid: cutInvalid }"
                           class="radio-container fit-box" :title="value.name">
                        <img :src="$imageUrl('cut-' + value.id + '.svg')" :alt="value.name">

                        <span class="option-name">
                            {{ value.name }}
                        </span>

                        <div>
                            {{ value.description }}
                        </div>

                        <input type="radio" class="select" name="cut" :value="value.id" v-model="cut"
                               @click="cut ? cut = null : ''">
                        <span class="checkmark"></span>
                    </label>
                </div>
            </template>
			<div class="col-12 desktop-only mt-4">
				<div class="proceed-box">
					<h3 class="heading">{{ $tr.product.totalPrice }} <strong>{{ $db.totalPrice() }}</strong></h3>
					<div class="buttons-wrapper">
						<Button @click="$emit('goToStep', '-1')" type="go-back" size="small">{{ $tr.backBtn }}</Button>
						<Button @click="addToCart" type="success" size="lg" icon="cart" :loading="cartLoading" v-if="shirtConfigured">
							{{ $tr.summary.addToCart }}
						</Button>
                        <a :href="$apiRoutes.goToCart" v-else>
                            <Button type="success" size="lg" icon="cart" :loading="cartLoading">
                                    {{ $tr.summary.goToCart }}
                            </Button>
                        </a>
					</div>
				</div>
			</div>
			<div class="not-desktop">
				<BottomBar @goToStep="$emit('goToStep', $event)" :customButtons="true">
					<slot name="progress"></slot>

					<template v-slot:custom-buttons>
						<Button @click="addToCart" type="success" size="lg" icon="cart" :loading="cartLoading" v-if="shirtConfigured">
							{{ $tr.summary.addToCart }}
						</Button>
                        <a :href="$apiRoutes.goToCart" v-else>
                            <Button type="success" size="lg" icon="cart">
                                    {{ $tr.summary.goToCart }}
                            </Button>
                        </a>
					</template>

				</BottomBar>
			</div>
            <div class="col-12 summary-box" v-if="$backendConfig.settings.displayUpselling">
                <div class="row mt-4">
                    <div class="col-12">
                        <h2 class="heading main-heading">{{ $tr.summary.accessories.heading }}</h2>
                    </div>
                    <div v-for="product in this.$generalData.accessories.products" :key="product.id" class="col-12 col-md-6 col-lg-4 col-xl-6 additional-product-container">
                        <div class="container">
                            <div class="additional-product-box row"
                                 :class="{ 'in-cart': $db.accessoriesInCart.includes(product.id) }"
                            >
                                <div class="col-5">
                                    <img :src="product.images[
                                        product.colors && product.colors.length && accessoriesColors[product.id]
                                        ? Math.min(Math.max(product.colors.indexOf(accessoriesColors[product.id]), 0), product.images.length - 1) // color picked -> show its image
                                        : 0
                                    ]" :alt="product.name"
                                         @click="showAccessoryDetail = true; accessoryDetailId = product.id">
                                </div>
                                <div class="col-7">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="heading">{{ product.name }}</h2>
                                        </div>
                                        <div class="col-12" v-if="product.embroidery && !$db.accessoriesInCart.includes(product.id)">
                                            <input v-model="accessoriesEmbroideries[product.id]"
                                                   :placeholder="$tr.summary.accessories.embroidery"
                                                   maxlength="2"
                                                   :class="`text-input${embroideryError === product.id ? ' invalid' : ''}`"
                                                   @input="() => { embroideryError = accessoriesEmbroideries[product.id].trim().length === 0 ? product.id : null }">
                                        </div>
                                        <label v-if="product.sizes && product.sizes.length && !$db.accessoriesInCart.includes(product.id)" class="col-12 size-label">
                                            {{ $tr.summary.accessories.size }}:
                                            <select v-model="accessoriesSizes[product.id]">
                                                <option
                                                    v-for="size in product.sizes"
                                                    :key="size"
                                                    :value="size"
                                                >
                                                    {{ size }}
                                                </option>
                                            </select>
                                        </label>
                                        <label v-if="product.colors && product.colors.length && !$db.accessoriesInCart.includes(product.id)" class="col-12 color-label">
                                            {{ $tr.summary.accessories.color }}:
                                            <select v-model="accessoriesColors[product.id]">
                                                <option
                                                    v-for="color in product.colors"
                                                    :key="color"
                                                    :value="color"
                                                >
                                                    {{ color }}
                                                </option>
                                            </select>
                                        </label>
                                        <!--<div class="col-3 pl-1 text-center">
                                            <img :src="product.mainImage" :alt="product.name" class="product-icon" width="50">
                                        </div>-->
                                        <template v-if="$db.accessoriesInCart.includes(product.id)">
                                            <div class="col-6 pr-xl-1">
                                                <button
                                                    class="button success-btn text-center centered-btn"
                                                    disabled>
                                                    {{ $tr.summary.accessories.added }}
                                                </button>
                                            </div>
                                            <div class="col-6 pl-1">
                                                <button
                                                    class="button sand-btn text-center centered-btn"
                                                    @click="removeAccessoryFromCart(product.id)">
                                                    {{ $tr.summary.accessories.remove.btn }}
                                                </button>
                                            </div>
                                        </template>
                                        <div v-else class="col-12 mt-auto price-button-wrapper">
                                            <button
                                                class="button success-btn text-center centered-btn"
                                                @click="addAccessoryToCart(product.id, accessoriesSizes[product.id], accessoriesEmbroideries[product.id], accessoriesColors[product.id])">
                                                + {{ $tr.summary.accessories.add.btn }}
                                            </button>
                                            <div class="button-price">
                                                {{ product.price }}
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <button
                                                class="button grey-btn text-center centered-btn mt-2" @click="showAccessoryDetail = true; accessoryDetailId = product.id">
                                                {{ $tr.summary.accessories.detail }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		</div>
        <SummaryAccessoryModal v-model="showAccessoryDetail" :accessory-detail-id="accessoryDetailId" @addAccessoryToCart="addAccessoryToCart(accessoryDetailId, $event.size, $event.embroidery, $event.color)" @removeAccessoryFromCart="removeAccessoryFromCart(accessoryDetailId)" />
	</div>
</template>

<script>
	import Button from "./common/Button";
	import BottomBar from "./ProductPickerPage/BottomBar";
    import SummaryAccessoryModal from "./common/SummaryAccessoryModal";
	import {EventBus} from "../event-bus";

	export default {
		name: "SummaryPage",
		components: {
			Button,
			BottomBar,
            SummaryAccessoryModal,
		},
		props: [
			"categories",
			"measurementsBeginStep",
            "shirtConfigured",
		],
		data() {
			return {
				configuration: {
					id: null,
					url: null
				},
                accessoriesSizes: {},
                accessoriesColors: {},
                accessoriesEmbroideries: {},
                embroideryError: null,
                showAccessoryDetail: false,
                accessoryDetailId: 0,
                cutInvalid: false,
                cartLoading: false,
			};
		},
        mounted() {
            for (let product of this.$generalData.accessories.products) {
                this.$set(this.accessoriesSizes, product.id, product.sizes && product.sizes.length ? product.sizes[0] : null);
                this.$set(this.accessoriesColors, product.id, product.colors && product.colors.length ? product.colors[0] : null);
                this.$set(this.accessoriesEmbroideries, product.id, product.embroidery ? "" : null);
            }
        },
		computed: {
			orderNote: {
				get() {
					return this.$db.note;
				},
				set(value) {
					this.$set(this.$db, "note", value);
				}
			},
            cut: {
                get() {
                    return this.$db.measurements.cut;
                },
                set(value) {
                    this.$set(this.$db.measurements, "cut", value);
                    this.cutInvalid = !this.cut;
                }
            },
            requireCut() {
			    return this.$db.measurements.type === "body" || this.$db.measurements.type === "table";
            }
		},
		methods: {
			addToCart() {
			    if (this.requireCut && !this.cut)
                    return this.cutInvalid = true;

                this.cartLoading = true;

                this.$api("saveConfiguration", {
                    configurator: this.$db,
                    general: this.$settings
                })
                    .then(data => {
                        this.configuration = data.data;

                        this.$api("addToCart", {
                            id: this.$generalData.shirtProductId,
                            quantity: 1,
                            configurationId: this.configuration.id,
                            note: this.orderNote,
                            editBasket: this.$settings.editBasket ? this.$settings.originalSlug : null,
                        })
                            .then(data => {
                                window.gtm.addToCart(this.configuration.id, this.$db.products.fabrics.name, data.data.singlePrice, 1, this.$backendConfig.settings.currency);

                                // Replace current URL with a slugless one (to ask the customer if they want to edit a cart shirt in case they press the back button)
                                const step = this.measurementsBeginStep + 1;
                                const lastStepUrl = this.constructUrl(step, false);
                                history.replaceState({step}, undefined, lastStepUrl);

                                this.$emit("addedToCart");
                            })
                            .catch((e) => {
                                EventBus.$emit("flash-message", this.$tr.summary.accessories.add.error, "error");
                            })
                            .finally(() => {
                                this.cartLoading = false;
                            });
                    })
                    .catch(() => {
                        EventBus.$emit("flash-message", this.$tr.summary.accessories.add.error, "error");
                        this.cartLoading = false;
                    });
			},

			addAccessoryToCart(id, size = null, embroidery = null, color = null) {
                if (embroidery !== null && embroidery.trim().length === 0) {
                    this.embroideryError = id;
                    return;
                }

				this.$api("addToCart", {
					id: id,
					quantity: 1,
					// note: this.configuration.id,
                    size,
                    embroidery,
                    color,
				}).then(data => {
					window.gtm.addToCart(id, data.data.name, data.data.singlePrice, 1, this.$backendConfig.settings.currency);
					this.$db.accessoriesInCart.push(id);
					EventBus.$emit("flash-message", this.$tr.summary.accessories.add.done, "success");
				}).catch(() => {
					EventBus.$emit("flash-message", this.$tr.summary.accessories.add.error, "error");
				});
			},

			removeAccessoryFromCart(id) {
				this.$api("removeFromCart", {
					removeId: id,
					quantity: 1,
				}).then(data => {
					window.gtm.removeFromCart(id, data.data.gtm.name, data.data.gtm.price, 1, this.$backendConfig.settings.currency);
                    this.$db.accessoriesInCart.splice(this.$db.accessoriesInCart.indexOf(id), 1);
					EventBus.$emit("flash-message", this.$tr.summary.accessories.remove.done, "success");
				}).catch(() => {
					EventBus.$emit("flash-message", this.$tr.summary.accessories.remove.error, "error");
				});
			}
		}
	}
</script>
